import { ENV } from "@-/com.npmjs.varlock/env";

/**
 * The configured base URL of the `haniverse-worker` Cloudflare Worker (the sqlite-proxy the
 * content/static DB handles POST their read-only SQL to, and the host of level packs, voice and
 * translation models).
 *
 * Reads `EXPO_PUBLIC_HANIVERSE_WORKER_URL` from `process.env` FIRST, then falls back to the varlock
 * `ENV` proxy. Dev no longer publishes the value via Infisical: the `vpx _dev` launcher injects it
 * into Metro's env, and a bundle built without it has the `ENV` read inlined as `undefined`, so only
 * `process.env` keeps a runtime-injected value reachable. On bare-Node runners (the Maestro server
 * in `configs/maestro/server`, a private bin entry) varlock's auto-init hasn't run, so touching `ENV`
 * throws "varlock ENV not initialized"; the access is guarded. On workerd (the deployed web server,
 * the dev `+api` routes) `process.env` isn't populated but the babel-inlined `ENV` proxy is.
 */
export function readConfiguredHaniverseWorkerUrl(): string {
  const fromProcess = process.env.EXPO_PUBLIC_HANIVERSE_WORKER_URL?.trim();
  if (fromProcess != null && fromProcess.length > 0) {
    return fromProcess;
  }
  try {
    const fromVarlock = ENV.EXPO_PUBLIC_HANIVERSE_WORKER_URL;
    if (fromVarlock != null && fromVarlock.length > 0) {
      return fromVarlock;
    }
  } catch {
    /* varlock ENV uninitialized (bare-Node runner) */
  }
  throw new Error("EXPO_PUBLIC_HANIVERSE_WORKER_URL is required.");
}
